<template>
    <router-view v-if="authStore.user" />
</template>

<script setup>
import { useAuthStore } from './stores/authStore.js'

const authStore = useAuthStore()
</script>
